// Detecta o slug da prefeitura pelo subdomínio
export function useSlug() {
  const hostname = window.location.hostname
  // Ex: santarosa.protogov.com.br → santarosa
  // Ex: localhost → null (usa o slug padrão)
  
  const partes = hostname.split('.')
  
  // Se for localhost ou protogov.com.br direto, sem subdomínio
  if (partes.length <= 2 || hostname === 'localhost' || hostname.startsWith('192.168') || partes[0] === 'www') {
    return null
  }
  
  // Subdomínios especiais que não são prefeituras
  const reservados = ['api', 'www', 'cidades', 'superadmin', 'mail', 'ftp']
  if (reservados.includes(partes[0])) {
    return null
  }
  
  return partes[0] // ex: santarosa, camara-santarosa
}
